import React from 'react';
import styled, { css } from 'styled-components';
import Link from 'next/link';
import { TEMPLATE as PAGE_TEMPLATE } from 'constants/pages';
import { FormattedMessage } from 'i18n';
import TravelSafeLink from 'components/banner/banners/travelSafe/TravelSafeLinkComponent';
import PaymentOptionsLogos from '../paymentOptionsLogos/PaymentOptionsLogos';
import { mediaQueries } from 'styles/utils/mediaQueries';

function PromotionsComponent({ co2Compensation, paymentOptionsLogos, styles, airlineWhitelabel }) {
  return (
    <Root styles={styles}>
      {paymentOptionsLogos && <PaymentOptionsLogos />}
      {co2Compensation && (
        <Link href={PAGE_TEMPLATE} as={'/climate-compensation'}>
          <a target='_blank' style={{ display: 'block' }}>
            <Wrapper>
              <CO2Image
                src={
                  'https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/240/apple/232/deciduous-tree_1f333.png'
                }
              />
              <FormattedMessage
                id={'co2compensation.message'}
                description={'CO2 Compensation for flight included.'}
                defaultMessage={'CO2 Compensation for flight included.'}
              />
            </Wrapper>
          </a>
        </Link>
      )}
      {/* Travel Safe component disabled for now */}
      {/*<TravelSafeLink />*/}
    </Root>
  );
}

export default PromotionsComponent;

const Root = styled.div`
  > *:not(:last-child) {
    margin-bottom: 16px;
  }

  ${({ styles }) =>
    styles &&
    css`
      ${styles}
    `};
`;

const Wrapper = styled.div`
  font-size: 1.4em;
  font-weight: 600;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.text.dark};
  vertical-align: middle;

  ${mediaQueries.fromAndAbove.desktop`
    text-align: initial;
  `}
`;

const CO2Image = styled.img`
  width: 21px;
  margin-right: 1rem;
  vertical-align: middle;
`;
